export default __webpack_public_path__ + "static/media/xtreme-project-1.7a64bae8.webp";